import * as types from './../types/empresas';

const INITIAL_STATE = {
  loading: false,

  empresas: [],

};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_EMPRESAS:
      return { ...state, empresas: action.payload };

    case types.LOADING_EMPRESAS:
      return { ...state, loading: action.payload };

    default:
      return state;
  }
};